module.exports = __webpack_public_path__ + "static/img/pic33.3323548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic33.png
// module id = qsWx
// module chunks = 1